/** Tope de filas en la vista previa (apply usa el alcance completo). */
export const BULK_COEFFICIENT_PREVIEW_FETCH_LIMIT = 500;

/** Filas por página en la preview paginada. */
export const BULK_COEFFICIENT_PREVIEW_PAGE_SIZE = 40;
